import React, { useState } from "react";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import "./CommonHierarchicalTable.css";
import CaretDoubleDown from "../../img/CaretDoubleDown.svg";
import CaretDoubleUp from "../../img/caretDoubleUp.svg";
/* ─── Pagination ─────────────────────────────────────────────── */
function HTPagination({
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50, 100, 500, 1000],
}) {
  const from = totalCount === 0 ? 0 : page * rowsPerPage + 1;
  const to = Math.min(totalCount, (page + 1) * rowsPerPage);
  const isFirst = page === 0;
  const isLast = to >= totalCount;

  return (
    <div className="ht-pagination">
      <div className="ht-per-page-pill">
        <select
          className="ht-per-page-select"
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
        >
          {rowsPerPageOptions.map((n) => (
            <option key={n} value={n}>
              {n} per page
            </option>
          ))}
        </select>
        <svg className="ht-per-page-chevron" viewBox="0 0 16 16" fill="none">
          <path
            d="M4 6l4 4 4-4"
            stroke="#6b7280"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <div className="ht-range-pill">
        {from}–{to} of {totalCount}
        <span className="ht-divider" />
        <button
          className="ht-arrow-btn"
          onClick={(e) => onPageChange(e, page - 1)}
          disabled={isFirst}
          aria-label="Previous page"
        >
          <KeyboardArrowLeftIcon className="ht-arrow-icon" />
        </button>
        <button
          className="ht-arrow-btn"
          onClick={(e) => onPageChange(e, page + 1)}
          disabled={isLast}
          aria-label="Next page"
        >
          <KeyboardArrowRightIcon className="ht-arrow-icon" />
        </button>
      </div>
    </div>
  );
}

/* ─── CommonHierarchicalTable ────────────────────────────────── */
export default function CommonHierarchicalTable({
  parentColumns = [],
  childColumns = [],
  rows = [],
  rowKey = (_, i) => i,
  childRowKey = (_, i) => i,
  page = 0,
  rowsPerPage = 10,
  totalCount = 0,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50, 100, 500, 1000],
  onRowExpand,
  renderChildSection,
  rootStyle,            // (optional)
  tableContainerStyle,  // (optional)
}) {
  const [expandedRow, setExpandedRow] = useState(null);

  // const toggle = (key) => setExpandedRow((prev) => (prev === key ? null : key));
  const toggle = (key, row) => {
    setExpandedRow((prev) => {
      const next = prev === key ? null : key;
      if (next !== null && onRowExpand) {
        onRowExpand(row);
      }
      return next;
    });
  };

  const colCount = parentColumns.length;

  return (
    <div className="ht-root"style={rootStyle}>
      <div className="ht-table-container" style={tableContainerStyle}>
        <table className="ht-table" aria-label="hierarchical table">
          {/* ── Parent header ── */}
          <thead>
            <tr className="ht-head-row">
              {parentColumns.map((col, colIdx) => {
                const hasSub = col.subColumns && col.subColumns.length > 0;
                return (
                  <th
                    key={col.id}
                    className="ht-head-cell"
                    rowSpan={hasSub ? 1 : 2}
                    colSpan={hasSub ? col.subColumns.length : 1}
                    style={{
                      // textAlign: col.align || "left",
                        textAlign: hasSub ? "center" : (col.align || "left"),
                      minWidth: col.minWidth || (hasSub ? 180 : 100),
                      borderRight: hasSub ? "1px solid #e5e7eb" : "none",
                      background:col.label ==="First Ignition On" ? "#52b352" :col.label==="Last Ignition Off" && "#f32e2e",
                      color:
                      col.label==="First Ignition On" ? "white" : col.label==="Last Ignition Off" 
                     ? "white":""
                    }}
                  >
                    {colIdx === 0 ? (
                      <span className="ht-sno-cell">
                        <span className="ht-toggle-btn" style={{ visibility: "hidden" }} />
                        {col.label}
                      </span>
                    ) : (
                      col.label
                    )}
                  </th>
                );
              })}
            </tr>
            {parentColumns.some(c => c.subColumns) && (
              <tr className="ht-head-row ht-head-row--sub">
                {parentColumns
                  .filter(c => c.subColumns)
                  .flatMap(c => c.subColumns)
                  .map(sub => (
                    <th
                      key={sub.id}
                      className="ht-head-cell ht-head-cell--sub"
                      style={{
                        textAlign: "center",
                        fontSize: "11px",
                        padding: "6px 16px",
                        borderLeft: "1px solid #e5e7eb",
                      }}
                    >
                      {sub.label}
                    </th>
                  ))
                }
              </tr>
            )}
          </thead>

          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={parentColumns.reduce((acc, c) => acc + (c.subColumns?.length || 1), 0)} className="ht-empty-cell">
                  No records found
                </td>
              </tr>
            )}

            {rows.map((row, rowIdx) => {
              const key = rowKey(row, rowIdx);
              const isExpanded = expandedRow === key;
              const children = row.children || [];
              const totalColSpan = parentColumns.reduce((acc, c) => acc + (c.subColumns?.length || 1), 0);

              return (
                <React.Fragment key={key}>
                  {/* ── Parent row ── */}
                  <tr
                    className={`ht-parent-row${isExpanded ? " ht-parent-row--expanded" : ""}`}
                    // onClick={() => toggle(key)}
                    onClick={() => toggle(key, row)}
                  >
                    {parentColumns.flatMap((col, colIdx) => {
                      if (col.subColumns) {
                        return col.subColumns.map(sub => (
                          <td
                            key={sub.id}
                            className={`ht-body-cell${isExpanded ? " ht-body-cell--expanded" : ""}`}
                            style={{ textAlign: "center" }}
                          >
                            {sub.render ? sub.render(row, rowIdx,isExpanded) : row[sub.id]}
                          </td>
                        ));
                      }
                      return (
                        <td
                          key={col.id}
                          className={`ht-body-cell${isExpanded ? " ht-body-cell--expanded" : ""}`}
                          style={{ textAlign: col.align || "left" }}
                        >
                          {colIdx === 0 ? (
                            <span className="ht-sno-cell">
                              <span className="ht-toggle-btn">
                                {isExpanded ? (
                                  <img src={CaretDoubleUp} alt="collapse" />
                                ) : (
                                  <img src={CaretDoubleDown} alt="expand" />
                                )}
                              </span>
                              {col.render ? col.render(row, rowIdx) : row[col.id]}
                            </span>
                          ) : col.render ? (
                            col.render(row, rowIdx)
                          ) : (
                            row[col.id]
                          )}
                        </td>
                      );
                    })}
                  </tr>

                  {/* ── Child section ── */}
                  {isExpanded && (
                    <tr className="ht-child-wrapper-row">
                      <td
                        colSpan={totalColSpan}
                        style={{ padding: 0, border: "none" }}
                      >
                        {renderChildSection ? (
                          renderChildSection(row, rowIdx)
                        ) : (
                          <div className="ht-child-scroll">
                            <table className="ht-child-table">
                            {/* Child header */}
                            <thead>
                              <tr className="ht-child-header-row">
                                {childColumns.map((col) => {
                                  const hasSub = col.subColumns && col.subColumns.length > 0;
                                  return (
                                    <th
                                      key={col.id}
                                      className="ht-child-header-cell"
                                      rowSpan={hasSub ? 1 : (childColumns.some(c => c.subColumns) ? 2 : 1)}
                                      colSpan={hasSub ? col.subColumns.length : 1}
                                      style={{
                                        textAlign: col.align || "left",
                                        minWidth: col.minWidth || (hasSub ? 180 : 80),
                                        borderRight: hasSub ? "1px solid #e5e7eb" : "none",
                                      }}
                                    >
                                      {col.label}
                                    </th>
                                  );
                                })}
                              </tr>
                              {childColumns.some(c => c.subColumns) && (
                                <tr className="ht-child-header-row">
                                  {childColumns
                                    .filter(c => c.subColumns)
                                    .flatMap(c => c.subColumns)
                                    .map(sub => (
                                      <th
                                        key={sub.id}
                                        className="ht-child-header-cell"
                                        style={{
                                          textAlign: "left",
                                          fontSize: "11px",
                                          padding: "6px 16px",
                                          borderLeft: "1px solid #e5e7eb",
                                        }}
                                      >
                                        {sub.label}
                                      </th>
                                    ))
                                  }
                                </tr>
                              )}
                            </thead>

                            {/* Child rows */}
                            <tbody>
                              {children.length === 0 ? (
                                <tr className="ht-child-row">
                                  <td
                                    colSpan={childColumns.reduce((acc, c) => acc + (c.subColumns?.length || 1), 0)}
                                    className="ht-body-cell"
                                    style={{
                                      textAlign: "center",
                                      color: "#9ca3af",
                                    }}
                                  >
                                    No Data
                                  </td>
                                </tr>
                              ) : (
                                children.map((child, childIdx) => (
                                  <tr
                                    key={childRowKey(child, childIdx)}
                                    className="ht-child-row"
                                  >
                                    {childColumns.flatMap((col) => {
                                      if (col.subColumns) {
                                        return col.subColumns.map(sub => (
                                          <td
                                            key={sub.id}
                                            className="ht-body-cell ht-child-cell"
                                            style={{ textAlign: "center" }}
                                          >
                                            {sub.render
                                              ? sub.render(child, childIdx, row)
                                              : child[sub.id]}
                                          </td>
                                        ));
                                      }
                                      return (
                                        <td
                                          key={col.id}
                                          className="ht-body-cell ht-child-cell"
                                          style={{
                                            textAlign: col.align || "left",
                                          }}
                                        >
                                          {col.render
                                            ? col.render(child, childIdx, row)
                                            : child[col.id]}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                        )}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>

      <HTPagination
        page={page}
        rowsPerPage={rowsPerPage}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
      />
    </div>
  );
}
